import Button from "@/components/bricks/button/Button";
import CloseSmallIcon from "../icons/CloseSmallIcon";

export default function Vedhaeftelse(props: {
  fil: File | IVedhaeftelse;
  onRemove: () => void;
}) {
  const { fil, onRemove } = props;
  const fileName = "dokument" in fil ? fil.navn : fil.name;
  const fileType = "dokument" in fil ? fil.mediaType : fil.type;

  return (
    <div className="btn btn--sm bg-light border d-flex gap-2 align-items-center pe-1">
      <div className="text-truncate text-sm" style={{ maxWidth: 200 }}>
        {fileName}
      </div>
      <small className="text-muted">{fileType}</small>
      <Button
        type="button"
        icon
        transparent
        aria-label={`Fjern ${fileName}`}
        color="secondary"
        className="btn--sm tooltip-top"
        onClick={onRemove}
      >
        <CloseSmallIcon />
      </Button>
    </div>
  );
}
